import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const forkliftDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "forklift-detect-example",
  version: 1,
  title: "Warehouse",
  description: "Track equipment and loads",
  subdescription: "Locate forklifts, the boxes they carry, and the nearest exit.",
  thumbnailUuid: BASE_ASSETS.forkliftWarehouseExample.uuid,
  assets: [BASE_ASSETS.forkliftWarehouseExample],
  detect: {
    mediaUuid: BASE_ASSETS.forkliftWarehouseExample.uuid,
    categories: ["box on forklift", "forklift", "exit"],
    config: {
      output: "box",
    },
  },
};
